import { UseQueryResult } from '@tanstack/react-query'
import { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { watchTaskUntilFinished } from '@/features/FormUploader/actions/watchTaskUntilFinished'
import { IShotlist } from '@/types/shotlist.interface'
import { ILanguage } from '@/types/task.interface'

interface ITranscribeShotlistOriginalParams {
	taskId?: string
	language: string
	selectedTranscribingLang: ILanguage
	watchTask: (
		taskId: string,
		onUpdate?: (shotlist: IShotlist) => void,
		onFinished?: (shotlist: IShotlist) => void
	) => Promise<void>
	clearWatch: () => void
	setIsTranscribing: Dispatch<SetStateAction<boolean>>
	setSelectedTranscribingLang: Dispatch<SetStateAction<ILanguage | null>>
	refetchShotlist: UseQueryResult<IShotlist, unknown>['refetch']
}

export const transcribeShotlistOriginal = async ({
	taskId,
	language,
	selectedTranscribingLang,
	watchTask,
	clearWatch,
	setIsTranscribing,
	setSelectedTranscribingLang,
	refetchShotlist
}: ITranscribeShotlistOriginalParams): Promise<void> => {
	if (!taskId || !language || !selectedTranscribingLang) return

	const onWatchUntilFinished = () => {
		return watchTaskUntilFinished({
			taskId,
			watchTask,
			clearWatch,
			onProgress: () => {},
			onFinally: () => {
				setIsTranscribing(false)
				setSelectedTranscribingLang(null)
			}
		})
	}

	try {
		setIsTranscribing(true)

		await ShotlistsService.updateShotlistLanguage(taskId, language)
		await ShotlistsService.transcribeShotlist(taskId)

		await onWatchUntilFinished()
		await refetchShotlist()
	} catch (error) {
		setIsTranscribing(false)
		console.log(error)
	}
}
